export default __webpack_public_path__ + "static/media/tempTrailerBgM.ca109f1d.jpg";